import React, { useState, useEffect } from "react";
import Logo from "../../assets/images/logo.png";

const Navigation = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // Adjust the scroll threshold as needed
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    // ===============  header area start ===============
    <header>
      {/* class="header-area header-defult sticky" */}
      <div className={`header-area header-defult ${scrolled ? "sticky" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-12 align-items-center d-xl-flex d-lg-block">
              <div className="nav-logo d-flex justify-content-between align-items-center">
                <a href="index.html">
                  <img src={Logo} alt="logo" />
                </a>

                <div className="d-flex align-items-center gap-4">
                  <div className="mobile-menu d-flex ">
                    <a
                      onClick={toggleMobileMenu}
                      className={`hamburger d-block d-xl-none ${
                        showMobileMenu ? "h-active" : ""
                      }`}
                    >
                      <span className="h-top"></span>
                      <span className="h-middle"></span>
                      <span className="h-bottom"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9">
              <nav
                className={`main-nav float-end ${
                  showMobileMenu ? "slidenav" : ""
                }`}
              >
                <div className="inner-logo d-xl-none text-center">
                  <a href="#">
                    <img src={Logo} alt="" />
                  </a>
                </div>
                <ul className="navigation">
                  <li>
                    <a href="#about" className="section-link">
                      About Me
                    </a>
                  </li>
                  <li>
                    <a href="#service" className="section-link">
                      Service
                    </a>
                  </li>
                  <li>
                    <a href="#portfolio" className="section-link">
                      Portfolio
                    </a>
                  </li>
                  <li>
                    <a href="#testimonial" className="section-link">
                      Testimonial
                    </a>
                  </li>
                  <li>
                    <a href="#blogs" className="section-link">
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a href="#contact" className="section-link">
                      Contact Me
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
    //===============  header area end ===============
  );
};

export default Navigation;
